// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sessionStartStyles{text-align:center}", "",{"version":3,"sources":["webpack://frontend/pages/Session/sessionStartStyles.scss"],"names":[],"mappings":"AAAA,oBACI,iBAAA","sourcesContent":[".sessionStartStyles {\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
